import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader';
// Redux Action
import messageManagementQuery from './messageManagement.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import { censorEmail, decode } from '../../../helpers/secureEmail';

import s from './MessageManagement.css';
import messages from '../../../locale/jsonMessages';
class MessageManagement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            currentPage: 1,
            searchList: '',
            typing: false,
            typingTimeout: 0,
            isRestrict: false
        }
        this.paginationData = this.paginationData.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    async componentDidMount() {
        const { demoRestrictionEncode } = this.props;
        const isRestrict = await demoRestrictionEncode();
        this.setState({ isRestrict });
    }

    paginationData(currentPage) {
        const { messageManagement: { refetch }, setStateVariable } = this.props;
        let variables = { currentPage };
        setStateVariable(variables);
        refetch(variables);
    }
    handleClick(searchList) {
        const { messageManagement: { refetch }, setStateVariable } = this.props;
        const { currentPage } = this.state;
        let variables = {
            currentPage: 1,
            searchList: searchList
        };
        setStateVariable(variables);
        refetch(variables);
    }
    handleSearchChange = (e) => {
        const self = this;
        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout);
        }
        self.setState({
            searchList: e.target.value,
            typing: false,
            typingTimeout: setTimeout(function () {
                self.handleClick(self.state.searchList);
            }, 450)
        });
    }

    thead = () => {
        const { formatMessage } = this.props.intl;
        return [
            { data: formatMessage(messages.reservationId) },
            { data: formatMessage(messages.carNameLabel) },
            { data: formatMessage(messages.hosting) },
            { data: formatMessage(messages.ownerEmailLabel) },
            { data: formatMessage(messages.traveling) },
            { data: formatMessage(messages.renterEmail) },
            { data: formatMessage(messages.titleRequiredLabel) },
        ]
    };


    tbody = (props) => {
        const { messageManagement: { loading, messageManagement }, locale, dynamicTitle } = props;
        const { isRestrict } = this.state;

        return messageManagement?.usersData?.length > 0 && messageManagement?.usersData?.map((value, index) => {
            let dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id: value?.listId });
            return {
                id: value?.id,
                data: [
                    {
                        data: index + 1
                    },
                    {
                        data:
                            <div>
                                <a
                                    target="_blank"
                                    href={"/cars/" + value.listId}
                                    className={cx(s.previewLink)}
                                >
                                    {dynamicListTitle || (value.listData ? value.listData.title : 'List is missing')}
                                </a>
                            </div>
                    },
                    {
                        data: value?.hostProfile?.displayName
                    },
                    {
                        data: value?.hostProfile?.profileId ? <div><a href={"/users/show/" + value.hostProfile.profileId} target="_blank" >
                            {!isRestrict ? decode(value?.hostUserEncryptData?.email) : censorEmail(decode(value?.hostUserEncryptData?.email))}
                        </a></div> : "-"
                    },
                    {
                        data: value?.guestProfile?.displayName ? value.guestProfile.displayName : ''
                    },
                    {
                        data: value?.guestProfile?.profileId ? <div><a href={"/users/show/" + value.guestProfile.profileId} target="_blank" >
                            {!isRestrict ? decode(value?.guestUserEncryptData?.email) : censorEmail(decode(value?.guestUserEncryptData?.email))}
                        </a></div> : "-"
                    },
                    {
                        data: <div><a target="_blank" href={"/message/" + value.id + "/owner"} className={cx(s.previewLink)}>
                            <FormattedMessage  {...messages.messageHistoryLabel} />
                        </a></div>
                    }

                ]
            }
        })
    }

    render() {
        const { messageManagement: { loading, messageManagement } } = this.props;
        const { currentPage } = this.props;
        const { formatMessage } = this.props.intl;

        if (loading) {
            return <Loader type={"text"} />
        }
        return (
            <div>
                <CommonTable
                    thead={this.thead}
                    tbody={() => this.tbody(this.props)}
                    title={formatMessage(messages.messages)}
                    isSearch
                    onSearch={this.handleSearchChange}
                />
                {
                    !loading && messageManagement?.usersData?.length > 0
                    && <div>
                        <CustomPagination
                            total={messageManagement.count}
                            currentPage={currentPage}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            change={this.paginationData}
                            paginationLabel={formatMessage(messages.messages)}
                        />
                    </div>
                }
            </div >
        );
    }

}

const mapState = (state) => ({
    completed: state.reservation.completed,
    loading: state.reservation.loading,
    locale: state?.intl?.locale,
    dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle
});

const mapDispatch = {
    demoRestrictionEncode
};

export default compose(
    injectIntl,
    withStyles(s),
    connect(mapState, mapDispatch),
    withQuery(messageManagementQuery, {
        name: 'messageManagement',
        options: (props) => ({
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(MessageManagement);